<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" :show-close="false" :close-on-click-modal="false">
      <div class="title">{{$t('compliance.title')}}</div>
      <div class="content">
        <p>{{$t("compliance.paragraph1")}}</p>
        <p>{{$t('compliance.paragraph2')}}</p>
        <p>{{$t('compliance.paragraph3')}}</p>
        <p>{{$t('compliance.paragraph4')}}</p>
        <p>{{$t('compliance.paragraph5')}}</p>
        <p>{{$t('compliance.paragraph6')}}</p>
        <p>{{$t('compliance.paragraph7')}}</p>
        <p>{{$t('compliance.paragraph8')}}</p>
        <p>{{$t('compliance.paragraph9')}}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="abandon" @click="abandon">{{$t('abandon')}}</el-button>
        <el-button class="confirm" @click="confirm">{{$t('confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialogVisible: false
    }
  },
  mounted () {
    this.dialogVisible = localStorage.getItem('dialogVisible') ? JSON.parse(localStorage.getItem('dialogVisible')) : true
  },
  methods: {
    abandon () {
      this.dialogVisible = false
      setTimeout(() => {
        this.dialogVisible = true
      }, 300)
    },
    confirm () {
      localStorage.setItem('dialogVisible', JSON.stringify(false))
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped lang="less">
.el-dialog {
  border-radius: 0.08rem;
}
.title {
  color: #141617;
  font-size: 0.44rem;
  font-weight: 700;
  text-align: left;
  margin-bottom: 0.4rem;
}
.content {
  width: 95%;
  height: 9rem;
  text-align: left;
  color: #666666;
  font-size: 0.28rem;
  overflow: auto;
  p {
    margin-bottom: 0.1rem;
  }
}
.dialog-footer {
  display: block;
  display: flex;
  justify-content: flex-end;
}
.el-button {
  padding: 0.26rem 0.9rem;
  color: #FFFFFF;
  font-size: 0.28rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.44rem;
}
.abandon {
  border: 1px solid #E2E2E2;
  color: #141617;
}
.confirm {
  background-color: #C91818;
}
</style>
